import { h, Component } from 'preact';
import { accessNested, sortObjectByOrder } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import { getHeaderHeight } from 'utils/bolt';
import Hero from 'components/bolt/hub/components/hero/hero';
import Carousel from 'components/bolt/hub/components/carousel/carousel';
import SideButton from 'components/bolt/hub/components/sideButton/sideButton';
import HeroCarousel from 'components/bolt/hub/components/heroCarousel/heroCarousel';
import 'store/bolt/hub';
import Store from 'store/store';
// import s from 'components/bolt/hub/hub.sss';

export default class Hub extends Component {

	constructor(props) {
		super(props);

		this.onResize = this.onResize.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.goToHash = this.goToHash.bind(this);
		this.scrollToTheElem = this.scrollToTheElem.bind(this);

		const pageContent = props.store?.appData?.pages?.[props.id];

		this.isSection = !!pageContent?.section;
		this.autoUpdateUrl = pageContent?.data?.autoUpdateUrl;
		this.heroCarousel = pageContent?.data?.heroCarousel;
		this.carousels = sortObjectByOrder(pageContent?.data?.carousels);
	}

	componentDidMount() {
		Store.emit('UPDATE_HUB_ACTIVE_PERCENTAGE');

		if (!this.isSection) {
			this.goToHash();
			window.setTimeout(() => {
				const scrollContainer = document.getElementById('mainScroll');
				scrollContainer.addEventListener('scroll', this.onScroll);
			}, 0);
		}

		if (this.autoUpdateUrl && !this.isSection) {
			window.addEventListener('resize', this.onResize);
			this.recalculateElementsPositions();
		}

		// IMPORTANT!! Keyboard navigation / accessibility
		// TODO: do this (or something similar) in boltApp
		const mainScroll = document.getElementById('mainScroll');
		if (mainScroll) {
			mainScroll.setAttribute('tabindex', -1);
			mainScroll.focus();
		}
	}

	componentWillUnmount() {
		Store.off('HUB_CAROUSEL_CLICK');
		window.removeEventListener('resize', this.onResize);
		document.getElementById('mainScroll')?.removeEventListener('scroll', this.onScroll);
	}

	onResize() {
		this.recalculateElementsPositions();
		this.checkActiveElement();
	}

	onScroll() {
		this.checkActiveElement();
	}

	recalculateElementsPositions() {
		if (!this.base || !this.autoUpdateUrl) {
			return;
		}

		this.parentTop = this.base.offsetTop;
		this.elements = [...this.base.children].filter(e => e.id).map(e => {
			return {
				url: e.id === 'top' ? '' : '#' + e.id,
				position: e.offsetTop + e.offsetHeight * .5 + this.parentTop
			};
		});
	}

	goToHash() {
		const hash = location.hash.slice(1);

		let scrollToElem = document.getElementById(hash || 'top');
		if (!scrollToElem) return;

		this.scrollToTheElem(scrollToElem);
		// Remove hash if the URL is not dynamically updated as we scroll
		if (!this.autoUpdateUrl) {
			history.replaceState(null, '', '');
		}
	}

	scrollToTheElem(scrollToElem) {
		const headerHeight = accessNested(this.props.store, 'client.headerHeight', getHeaderHeight());
		let scrollContainer = document.getElementById('mainScroll');
		window.setTimeout(() => {
			smoothScrollTo(scrollContainer, scrollToElem, 0, { offset: headerHeight });
		}, 0);
	}

	checkActiveElement() {
		if (!this.elements || !this.autoUpdateUrl) {
			return;
		}
		const scrollContainer = document.getElementById('mainScroll');
		let currentPosition = this.parentTop + scrollContainer.scrollTop + (window.innerHeight - this.parentTop) * .5;
		let withDistance = this.elements.map(e => ({ ...e, dist: Math.abs(e.position - currentPosition) }));
		let closest = withDistance.sort((a, b) => a.dist - b.dist)[0];
		let url = closest?.url;
		if (!closest || (this.currentPath && this.currentPath === url)) {
			return;
		}
		this.currentPath = url;
		let fullURL = new URL(url || '#', location.href);
		if (!url) {
			fullURL.hash = '';
		}
		if (location.href !== fullURL) {
			history.replaceState(null, '', fullURL.href);
		}
	}

	renderBottom() {
		// Do we need #bottom?
		// return <div id="bottom" />;
		return;
	}

	render({ store, id }) {
		const section = accessNested(store, `appData.pages.${id}.section`, '');
		const clientDimensions = accessNested(store, 'client.dimensions', {});
		const heroData = accessNested(store, `appData.pages.${id}.data.hero`, '');
		const fallbackFormat = accessNested(store, `appData.pages.${id}.data.alternativeImageFormat`, 'jpg');
		const sideButtonData = accessNested(store, `appData.pages.${id}.data.sideButton`, '');
		const useTileSlantyTag = accessNested(store, 'appData.options.carouselTilesUseSlantyTags', false);
		const desktopSolidHeader = accessNested(store, 'header.powsterHeader.desktopSolidHeader', false);
		const headerHeight = accessNested(store, 'client.headerHeight', '');
		const hubActivePercentage = accessNested(store, 'hubActivePercentage', 1);
		const appData = accessNested(store, `appData.pages.${id}.data`, {});
		const client = accessNested(store, 'client', '');

		return (
			<div style={{ marginTop: (!section && desktopSolidHeader) ? headerHeight : '' }} data-section={id}>
				{this.heroCarousel ? (
					<HeroCarousel
						appData={appData}
						data={this.heroCarousel}
						client={client}
						visible={hubActivePercentage >= 0.15}
						store={store}
					/>
				) : (
					<Hero
						data={heroData}
						clientDimensions={clientDimensions}
						fallbackFormat={fallbackFormat}
						visible={hubActivePercentage >= 0.15}
						hide={hubActivePercentage < 0.15}
						store={store}
					/>
				)}

				{this.carousels.map((carousel, i) => (
					<Carousel
						data={carousel}
						index={i}
						clientDimensions={clientDimensions}
						useTileSlantyTag={useTileSlantyTag}
						key={i}
						fallbackFormat={fallbackFormat}
						isHubCarousel
					/>
				))}
				{sideButtonData && <SideButton data={sideButtonData} />}
				{this.renderBottom()}
			</div>
		);
	}
}
